
// apps/web/src/services/api.js

import fetch from 'auth/FetchInterceptor'

export const api = fetch

export default fetch
